<h1 mat-dialog-title>{{data.title | translate:transform }}</h1>
<div mat-dialog-content>

  <div class="row">
    <div class="col-9">
      <div style="max-height:640px !important">
        <map-viewer name="dialog-all"></map-viewer>
			</div>
    </div>
    <div class="col-3">
      <mat-progress-spinner diameter="20" *ngIf="creatingQuickView"
                            mode="indeterminate"
      ></mat-progress-spinner>
      <p *ngIf="creatingQuickView"> {{message}} </p>
      <p *ngIf="loading"> {{loadingMessage}} </p>

      <!-- Quick view -->
      <button [disabled]="loading" class="full-width mt-2" [color]="'primary'" mat-raised-button
              [matTooltip]="'DIALOG.GENERATE_QUICK_VIEW' | translate" (click)="quickView()">{{'DIALOG.QUICK_VIEW' | translate }}
      </button>

      <!-- Select Area of Interest for Full Processing -->
      <button [disabled]="!askQuestion" class="full-width mt-2" color="primary" mat-raised-button [matTooltip]="'DIALOG.SELECT_AREA_OF_INTEREST' | translate" (click)="selectArea()">{{'DIALOG.SELECT_AREA' | translate }}</button>
    </div>
  </div>
</div>
<div mat-dialog-actions class="align-content-right">

<!-- OK button -->
  <button color="primary" mat-button (click)="onClick()">{{(data.posBtn ? data.posBtn : "GENERIC.OK") | translate }}
  </button>
</div>
